/**
 * Created by liujintao on 18/2/27.
 */
import $axios from 'axios';
import _ from 'lodash';
import utils from './utils'
import {document,localStorage} from './hack-env';
import {getSign} from '@/common/libs/common.js';
var serverDomain = "https://beta-zaixian.izhikang.com";
var newServerDomain = "https://beta-api-www.izhikang.com";
var mApiServerDomain = 'https://beta-api-m.izhikang.com/mw';
var complaintDomain = 'https://dev-complaint.izhikang.com';
console.log('当前环境：',process.env.NODE_ENV);
var roleList = 'https://beta-complaint.izhikang.com/complain/baseData/getFeedbackRole'
if(process.env.NODE_ENV=='production'){
  serverDomain = "https://zaixian.izhikang.com";
  newServerDomain = "https://api-www.izhikang.com";
  mApiServerDomain = 'https://api-m.izhikang.com/mw';
  complaintDomain = 'https://complaint.izhikang.com';
  roleList = complaintDomain +'/complain/baseData/getFeedbackRole';
  if(process.env.VUE_ENV === 'server'){
    newServerDomain = "https://api-www-inner.izhikang.com";
  }else{
    newServerDomain = "https://api-www.izhikang.com";
  }
}else if(process.env.NODE_ENV=='beta'){
  complaintDomain = 'https://beta-complaint.izhikang.com';
  roleList = complaintDomain +'/complain/baseData/getFeedbackRole';
  serverDomain = "https://beta-zaixian.izhikang.com";
  newServerDomain = "https://beta-api-www.izhikang.com";
  mApiServerDomain = 'https://beta-api-m.izhikang.com/mw';
}else if(process.env.NODE_ENV=='development'){
  complaintDomain = 'https://dev-complaint.izhikang.com';
  roleList = complaintDomain + '/complain/baseData/getFeedbackRole';
  serverDomain = "https://beta-zaixian.izhikang.com";
  newServerDomain = "https://beta-api-www.izhikang.com";
  mApiServerDomain = 'https://beta-api-m.izhikang.com/mw';
  // mApiServerDomain  = "http://dev-zaixian.izhikang.com:9901/mock/147"
}else if(process.env.NODE_ENV=='audit'){
  complaintDomain = 'https://beta-complaint.izhikang.com';
  serverDomain = "https://audit-zaixian.izhikang.com";
  newServerDomain = "https://audit-api-www.izhikang.com";
  mApiServerDomain = 'https://pre-api-m.izhikang.com/mw';
}

$axios.interceptors.response.use(data=> {
  return data;
}, err=> {
  console.log('err: ', err);
  //如何获取this对象, 处理断网情况获取vue类，实例化一个对象，再调用这个绑定到App对象的方法
  //return Promise.resolve(err);
  if (err.response.status == 504||err.response.status == 404) {
    return Promise.resolve({data:{errid:err.response.status,errmsg:'服务器开小差'}});
  }else if(err.response.status == 500){
    return Promise.resolve({data:{errid:err.response.status,errmsg:'服务器开小差(ಥ _ ಥ)'}});
  }else if(err.response.status!=200){
    return Promise.resolve({data:{errid:err.response.status,errmsg:'服务器开小差'}});
  }else if(!err.response.data.errid){
    console.log('内容无法解析======');
    return Promise.resolve({data:{errid:500,errmsg:'服务器返回数据异常无法解析'}});
  }
  return Promise.resolve(err);
});
//配合编译工具，指定模式屏蔽log
function API(path) {
  this.path = path;
}

_.extend(API.prototype,{
  post: function (data,options) {
    options = options||{};
    options.headers = _.extend({token:utils.cookie.get('token')|| localStorage.getItem('token')||utils.cookie.get('wxToken') || ''},options.headers||{});
    if(this.path.indexOf(mApiServerDomain)>-1){
      options.headers.channel = '10';
      options.headers.timestamp = Date.now().valueOf();
      options.headers.cityCode = utils.cookie.get('cityCode')||utils.cookie.get('wxCityCode')||'010';
    }
    data = data||{};
    if(options.headers['Content-Type'] == 'application/json'){
      var url  = this.getUrl('post',data);
      return $axios.post(url,JSON.stringify(data),options);
    } else {
      if(data&&!data.sign_type){
        delete data.sign;
        data.sign = getSign(data);
      } else {
        data.sign = utils.cookie.get('token')|| localStorage.getItem('token')||utils.cookie.get('wxToken') || '';
      }
      var url  = this.getUrl('post',data);
      return $axios.post(url,utils.jsonToSerializer(data),options);
    }
  },
  get: function (data,options) {
    options = options||{};
    options.headers = _.extend({token:utils.cookie.get('token')||localStorage.getItem('token')||utils.cookie.get('wxToken') || ''},options.headers||{});
    if(this.path.indexOf(mApiServerDomain)>-1){
      options.headers.channel = '10';
      options.headers.timestamp = Date.now().valueOf();
      options.headers.cityCode = utils.cookie.get('cityCode')||'010';
    }
    data = data||{};
    if(data&&!data.sign_type){
      delete data.sign;
      data.sign = getSign(data);
    } else {
      data.sign = utils.cookie.get('token')|| localStorage.getItem('token')||utils.cookie.get('wxToken') || '';
    }
    var url  = this.getUrl('get',data);
    return $axios.get(url+"?"+utils.jsonToSerializer(data),options)//;
  },
  get2:function (data,options){
    options = options||{};
    var url  = this.getUrl('get',data);
    return $axios.get(url+"?"+utils.jsonToSerializer(data),options)//;
  },
  put: function (data,options) {
    options = options||{};
    options.headers = _.extend({token:utils.cookie.get('token')|| localStorage.getItem('token')||utils.cookie.get('wxToken') || ''},options.headers||{});
    if(this.path.indexOf(mApiServerDomain)>-1){
      options.headers.channel = '10';
      options.headers.timestamp = Date.now().valueOf();
      options.headers.cityCode = utils.cookie.get('cityCode')||'010';
    }
    data = data||{};
    if(data){
      delete data.sign;
      data.sign = getSign(data);
    }
    var url  = this.getUrl('put',data);
    return $axios.put(url, data,options);
  },
  getUrl: function (method,data) {
    var path = (method !== 'POST' && data && !!data._id) ? this.path + '/<%=_id%>' : this.path;
    var url=this.url || _.template(path)(data);
    return url;
  }
});
API.prototype.server = serverDomain;
var apiMethod={};
var apiMap = {};
var apiUrlMap = {
  "roleList": roleList,
  "schools": mApiServerDomain + "/school/list", //没用到
  "appSlider": newServerDomain + "/api/slider/index_carousel_figure", //首页轮播图数据  //没用到
  "getCity": serverDomain + '/izk/index.php/izk_new_mobile/city/get_city',  //定位城市
  'getOpenCitys': serverDomain + '/izk/index.php/izk_new_mobile/city/get_open_citys',   //获取爱智康校区城市
  'getAllCitys': serverDomain + '/izk/index.php/izk_new_mobile/city/get_all_citys',  //获取所有城市列表
  'getSelections': serverDomain + '/izk/index.php/izk_new_mobile/city/get_selections', //获取表单配置内容
  'getSelections1': serverDomain + '/izk/index.php/izk_new_mobile/city/get_selections1', //获取表单配置内容
  'getSelections2': serverDomain + '/izk/index.php/izk_new_mobile/city/get_selections2', //获取表单配置内容
  'banner': serverDomain + '/izk/index.php/izk_new_mobile/drumbeating/head_wheel_chart',   //获取banner
  'navigation': serverDomain + '/izk/index.php/izk_new_mobile/drumbeating/classification_nav',   //导航分类
  'menuList': serverDomain + '/izk/index.php/izk_new_mobile/courses/get_menus_list',   //获取筛选条件
  'coursesList': serverDomain + '/izk/index.php/xes/courses/get_courses_list',  //获取选课中心课程列表
  'getCourseInfo': serverDomain + '/izk/index.php/izk_new_mobile/courses/get_course_info',  //获取课程详情信息
  'getQqDetail': serverDomain + '/izk/index.php/xes/Extra/get_qq_group_info',  //获取qq群详情
  'subscribeCourse': newServerDomain + '/api/subscribe/action', //预约报名
  'sendSms': newServerDomain + '/api/sms/send_sms', //短信验证码
  'commonLinks': serverDomain + '/izk/index.php/izk_new_mobile/user/common_header_and_footer',   //乐语链接
  //'logout': serverDomain + '/izk/index.php/izk_new_web/user/logout',  //退出登录
  'oldLogin': newServerDomain + '/api/user/login',  //登录
  'login': newServerDomain + '/api/ucenter/account_login',//对接用户中心 登录接口
  'logout': newServerDomain + '/api/user/logout', //退出登录
  //'setPassword': serverDomain + '/izk/index.php/izk_new_web/ucenter/set_password',  //重置密码
  'setPassword': newServerDomain + '/api/ucenter/init_pwd', //对接用户中心 重置密码
  "updatePassword": newServerDomain + "/api/user/set_password",//老的重置密码
  //'getUserReservations': serverDomain + '/izk/index.php/izk_new_web/ucenter/get_user_reservations',  //预约课程信息
  'getUserReservations': newServerDomain + '/api/subscribe/list', //预约课程信息
  "logo": serverDomain + '/izk/index.php/izk_new_mobile/drumbeating/contact_information', //获取logo信息
  "dataSet": serverDomain + '/izk/index.php/izk_new_mobile/data/data_set',  //data表单配置
  "onlineData": serverDomain + '/izk/index.php/izk_new_mobile/data/online_data_attr_for_grade_subject',  //在线表单备选项
  //"getUserInfo": serverDomain + '/izk/index.php/izk_new_web/ucenter/user_info',  //获取用户信息
  "getUserInfo": newServerDomain + '/api/ucenter/user_info',//对接用户中心 获取用户信息接口
  "courseBanner": serverDomain + '/izk/index.php/izk_new_mobile/drumbeating/course_center',  //选课中心轮播图
  "getCourseRecommend": serverDomain + "/izk/index.php/izk_new_mobile/courses/get_course_recommend",  //首页面授课推荐接口
  "getLoginIcon": serverDomain + "/izk/index.php/izk_new_mobile/drumbeating/recommend",  //获取登录页面icon
  //'getCodeImg': serverDomain + "/izk/index.php/welcome/captcha", //获取图形验证码
  'getCodeImg': newServerDomain + '/api/sitting/captcha',
  'wechat': serverDomain + "/izk/index.php/wxpay/get_wx_user_info",  //微信授权登录
  "binding": serverDomain + "/izk/index.php/izk_new_mobile/user/user_binding_wx",   //微信绑定
  "bubble": serverDomain + "/izk/index.php/izk_new_mobile/drumbeating/bubble",  //获取课程详情页的气泡
  "getSignPackage": serverDomain + "/izk/index.php/izk_new_mobile/weixin/getSignPackage",  //获取微信sdk的配置信息
  "getFeedbackMeta": serverDomain + "/izk/index.php/izk_new_web/feedback/get_info",//获取feedback基础信息
  // "submitFeedback": serverDomain + "/izk/index.php/izk_new_web/feedback/sub_answer",//提交feedback
  "submitFeedback": complaintDomain + "/complain/feedback/save",
  "uploadFeedbackPic": serverDomain + "/izk/index.php/izk_new_web/feedback/upload_img",//上传反馈图片
  "codeSend":newServerDomain + "/api/ucenter/vcode_send",//忘记密码获取短信
  "cehckUser":newServerDomain + "/api/ucenter/check_user",//忘记密码检查用户登录接口
  "forgetPwd":newServerDomain + "/api/ucenter/forget_pwd",//忘记密码重置密码

//新签 start
  "courseDateRange":mApiServerDomain + '/product/intention/queryTimeRange',
  "courseTimesheet":mApiServerDomain + '/product/intention/queryTimeSheet',
  //新签 end
  "courseNewSignDetail": mApiServerDomain + '/product/intention/detail',//bizId
  "courseNewSignSubmit":mApiServerDomain + "/order/submit",
  //h5直签
  "getCourseBottomInfo": mApiServerDomain + "/product/detail",//课程详情页-获取底部按钮
  "orderPreCheck": mApiServerDomain + "/order/pre/check",//课程详情页-购课点击时校验
  "getStudentCardBasicInfo": mApiServerDomain + "/studentCard/updateInfoDetail",//补充学员卡信息-表单项数据获取
  "updateStudentCardInfo": mApiServerDomain +"/studentCard/updateInfo",//补充学员卡信息-表单提交
  "getStudentCardList": mApiServerDomain +"/studentCard/list",//获取学员卡列表
  "getStudentCardInfo": mApiServerDomain +"/account/info",//获取当前使用的学员卡信息
  "switchStudentCard": mApiServerDomain +"/studentCard/switch",//学员卡切换
  "getOrderListInfo": mApiServerDomain +"/order/list",//获取订单列表
  //"getOrderListInfo":'http://mock.izhikang.com/mock/103/order/list',
  "cancelOrder": mApiServerDomain +"/order/cancel",//取消订单
  "getBuyEigthtCourseInfo": mApiServerDomain +"/product/pre/detail",//获取8人班购课信息


  "consultPlace":serverDomain + '/izk/index.php/xes/courses/get_school_list', //T分校在线课程新增咨询点查询接口
  "paySuccessDetail": mApiServerDomain + '/order/paySuccessDetail',//支付成功详细信息

  // 在线诊断课

  "imageCredential":mApiServerDomain + '/api/upload/imageCredential', //获取腾讯云配置
  "searchSchool":mApiServerDomain + '/school/reading', //获取腾讯云配置
  "studentCardRecord":mApiServerDomain + '/studentCard/studentCardRecord', //获取档案信息
  "recordSubmit":mApiServerDomain + '/studentCard/recordSubmit', //提交档案信息
  "checkLogin":mApiServerDomain + '/account/checkLogin', //登录校验

  "diagnosisCityGrade": mApiServerDomain + '/product/diagnosisCityGrade',  // 城市年级
  "getDiagnosis": mApiServerDomain + '/product/diagnosis',       // 获取诊断课信息
  "detail": mApiServerDomain + '/product/detail',         // 课程详情
  "productTimeCheck": mApiServerDomain + '/product/productStatusCheck',  // 可报课产品校验  不需要了  2020/11/3 启用
  "productTimePanel" : mApiServerDomain + '/product/timePanel',       // 报课时间校验
  "checkClassEnroll" : mApiServerDomain + '/product/timePanelCheck',  // 可报课程时段校验
  "timePanelSubmit": mApiServerDomain + '/order/timePanelSubmit'
};
apiMap.CodeMap = {
  Success:0,
  TokenExpired:20007,
  NoToken:20001,
  UserInvalid:20018,
  NewSignCourseRateEnum:{
    Unlimit:0,
    Daily:1,
    Weekly:2
  },
  SubjectDic:{
    0:{
      code:0,en:'all',cn:'全部'
    },
    1:{
        code:1,en:'Chinese',cn:'语文'
    },
    2:{
        code:2,en:'Math',cn:'数学'
    },
    3:{
        code:3,en:'English',cn:'英语'
    },
    4:{
        code:4,en:'Physical',cn:'物理'
    },
    5:{
        code:5,en:'Chemistry',cn:'化学'
    },
    6:{
        code:6,en:'Biology',cn:'生物'
    },
    7:{
        code:7,en:'History',cn:'历史'
    },
    8:{
        code:8,en:'Geography',cn:'地理'
    },
    9:{
        code:9,en:'Politics',cn:'政治'
    },
    10:{
        code:10,en:'Psychology',cn:'素质'
    }
  },
  GradeDic:{
    0:{
      code:0,cn:'全部'
    },
    1:{
        code:1,cn:'一年级'
    },
    2:{
        code:2,cn:'二年级'
    },
    3:{
        code:3,cn:'三年级'
    },
    4:{
        code:4,cn:'四年级'
    },
    5:{
        code:5,cn:'五年级'
    },
    6:{
        code:6,cn:'六年级'
    },
    7:{
        code:7,cn:'初一'
    },
    8:{
        code:8,cn:'初二'
    },
    9:{
        code:9,cn:'初三'
    },
    10:{
        code:10,cn:'高一'
    },
    11:{
        code:11,cn:'高二'
    },
    12:{
        code:12,cn:'高三'
    }
  }
};
_.each(apiUrlMap, function (path,key) {
  apiMethod[key] = new API(path);
});

apiMap.getServer=function(){
  return API.prototype.server;
};
apiMap.getNewServer = function(){
  return newServerDomain;
}
apiMap.apiMethod = apiMethod;

export default apiMap;



// WEBPACK FOOTER //
// ./src/common/libs/api.js